// // Use $ instead of jQuery without replacing global $
(function ($) {


  function wrappBlock() {
    $(".product-a-z .media-container .block-wrapper").unwrap();
    $(".product-a-z .media-container .block-wrapper h3").unwrap();
    $(".product-a-z .media-container .block-wrapper .cols-3").unwrap();
    $(".product-a-z .media-container").each(function (index, sel) {
      //Wrap 1 div in 1 div
      var n;
      var itemLength = $(".product-a-z .media-container .cols-3").length;
      // console.log(itemLength);
      for (var i = 0; i < itemLength; i += 1) {
        if (i < itemLength) {
          n = i + 1;
        }
        var row = $(sel).find(".cols-3").slice(i, n);
        row.wrapAll("<div class='block-wrapper'></div>");
      }

      var o;
      var itemLength1 = $(".product-a-z .media-container h3").length;
      // console.log(itemLength);
      for (var j = 0; j < itemLength1; j += 1) {
        if (j < itemLength1) {
          o = j + 1;
        }
        var row1 = $(sel).find("h3").slice(j, o);
        row1.wrapAll("<div class='block-wrapper'></div>");
      }

      //Wrap 2 divs in 1 div
      var p;
      var itemLength2 = $(".product-a-z .media-container .block-wrapper").length;
      // console.log(itemLength);
      for (var l = 0; l < itemLength2; l += 2) {
        if (l < itemLength2) {
          p = l + 2;
        }
        var row2 = $(sel).find(".block-wrapper").slice(l, p);
        row2.wrapAll("<div class='col-row wow-product fadeInUp'></div>");
      }
    });
  }

  // Set h3
  function setData() {

    $(".product-a-z .views-element-container h3").each(function (index) {
      var text = $(this).text().trim();
      $(this).attr('data-type', text);

      $('body .filter-block .col-wrap').append('<li class="col"></li>');
      setTimeout(function () {
        $('body .filter-block .col-wrap li:eq(' + (index) + ')').html(text).attr('data-type', text).addClass('we-active');
        $('.product-a-z .views-element-container .col-row:eq(' + (index) + ')').attr('data-title', text);
      }, 300);

    });

  }

  var select_geo;

  function select_option() {
    setTimeout(function () {
      select_geo = $('body').attr('data-region');
      // console.log(select_geo);
      // For product nav only

      if ((select_geo === 'australia')) {
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 117 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 116 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 118 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 76 + ']').css({ "display": 'block' });

        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 467 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 468 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 469 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 470 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 471 + ']').css({ "display": 'block' });

      } else if ((select_geo === 'new_zealand')) {
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 117 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 116 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 118 + ']').css({ "display": 'block' });

      } else if ((select_geo === 'africa')) {
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 117 + ']').css({ "display": 'block' });

      } else if ((select_geo === 'in')) {
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 116 + ']').css({ "display": 'block' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 118 + ']').css({ "display": 'block' });

      } else {
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 116 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 117 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 118 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 76 + ']').css({ "display": 'none' });

        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 467 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 468 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 469 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 470 + ']').css({ "display": 'none' });
        $('body .filter-box .selectboxit-container .selectboxit-options .selectboxit-option[data-val=' + 471 + ']').css({ "display": 'none' });
      }

    }, 500);
  }

  $(window).on('load', function () {
    // $('body .filter-block .col-wrap').empty();
    $('#views-exposed-form-product-block-1 .form-submit').trigger('click');
    var val = $("body .filter-block .filter-wrapper .category-wrapper select").val();
    $('body .filter-block .filter-wrapper .category-wrapper select').val(val).trigger('change');
    select_option();

    load_OnReady();
  });

  function product_filter() {
    // Change the Resource based on Region

    var geo = $('body').attr('data-region');

    $('.product-a-z .col-three span').each(function () {
      $(this).removeClass('New');

      if ($(this).hasClass('Australia') && (geo == 'australia')) {

      } else if ($(this).hasClass('Zealand') && (geo == 'new_zealand')) {

      } else if ($(this).hasClass('India') && (geo == 'in')) {

      } else if ($(this).hasClass('Africa') && (geo == 'africa')) {

      } else if ($(this).hasClass('Mexico') && (geo == 'mexico')) {

      } else if ($(this).hasClass('China') && (geo == 'china')) {

      } else if ($(this).hasClass('ExcludeChina') && (geo != 'china')) {

      } else if ($(this).hasClass('us')) {

      } else {
        $(this).parent().remove();
      }
    });

  }
  var flag = 0;
  $(document).ajaxComplete(function (e, xhr, settings) {

    wrappBlock();
    // load_OnReady();
    // $('body .filter-block ul.col-wrap').empty();
    // setData();
    setTimeout(function () {
      product_filter();
      $('.product-a-z .col-row').each(function () {
        var len = $(this).find('.col-three').length;
        if (len === 0) {
          $(this).remove();
        }
      });
      if (flag === 0) {
        $('.filter-block ul.col-wrap').empty();
        setData();
        flag = 1;
      }
      load_OnReady();
    }, 800);

  });

  // $(document).ajaxSuccess(function () {
  //   setTimeout(function () {
  //     console.log("ok");
  //     $('.filter-block .col-wrap .col').each(function () {
  //       console.log(this);
  //       var text = $(this).text();
  //       console.log(text);
  //       if (text === '') {
  //         $(this).remove();
  //         console.log(3);
  //       }
  //     });
  //   }, 1000);
  // });

  // Set filter on Click
  $(document).on('click', '.filter-block .col-wrap .col', function () {
    flag = 0;
    if (!$(this).hasClass('active')) {
      $('.filter-block .col-wrap .col').removeClass('active');
      $(this).addClass('active');
      var filtervalue = $(this).attr('data-type');
      if (filtervalue === 'all') {

      } else {
        $(".filter-block .media-container .col-row").each(function () {
          var filterdata = $(this).attr('data-type');
          var filtertitle = $(this).attr('data-title');

          if (filtervalue === filtertitle) {
            wow_product = new WOW(
              {
                boxClass: 'wow-product'
              }
            )
            wow_product.init();

            $(this).prevAll().removeClass('show-block pt-0').css({ "display": "none" });
            $(this).addClass('show-block pt-0').css({ "display": "block" });
            $(this).nextAll().addClass('show-block').css({ "display": "block" });
            $(this).nextAll().removeClass('pt-0');
            $('.filter-block .load-more').css({ 'display': 'none' });
          } else {
            // $(this).prevAll().removeClass('show-block');
          }
        });
      }
    }
  });


  /* Load more click count. */
  var item_show = 5,
    item_show_click = 4,
    length = '';

  /* Function to hide and show element on Load */
  function load_OnReady() {
    $('.filter-block .media-container').find('.col-row').each(function () {
      length = $(this).parents('.filter-block .media-container').find('.col-row').length;
      // console.log(length);
      var index = $(this).index();
      if (index >= item_show) {
        $(this).css('display', 'none').removeClass('active-filter');
      }
      else {
        //~DK this is causing error on rest of the pages
        if ($('.filter-block').length > 0) {
          $(this).css('display', 'block').addClass('active-filter');
        }
      }
      if (length <= item_show) {
        $(this).parents('.filter-block').find('.load-more').css('display', 'none');
      } else {
        $(this).parents('.filter-block').find('.load-more').css('display', 'inline-block');
      }
    });
  }

  /* Function to show element on Load more click */
  function loadMore() {
    var $i = 0;
    $('.filter-block .media-container .col-row').each(function () {
      var $dataDisplay = $(this).css('display');
      if ($dataDisplay == 'block') {
        $i++;
      }
    });
    if ($i < length) {
      for (var $j = $i; $j < ($i + item_show_click); $j++) {
        $('.filter-block .media-container .col-row').eq($j).css({ 'display': 'block' });
        if (($i + item_show_click) >= length) {
          $('.filter-block .load-more').css({ 'display': 'none' });
        }
      }
    } else {
      $('.filter-block .load-more').css({ 'display': 'none' });
    }
  }


  $(document).on('click', '.filter-block .load-more', function () {
    flag = 0;
    loadMore();
  });

  function clone_select() {
    $(".product-a-z .form-item-field-product-type-target-id select").clone().appendTo('.filter-block .filter-wrapper .category-wrapper');
  }

  if ($('.a2z').length > 0) {
    clone_select();
  }

  $(document).on('change', '.a2z .category-wrapper select', function (e) {
    flag = 0;
    // console.log(1);
    var value = $(this).val();
    var value2 = $('#views-exposed-form-product-block-1 .form-item-field-product-type-target-id select').val();
    if (value !== value2) {
      jQuery('#views-exposed-form-product-block-1 .form-item-field-product-type-target-id select').val(value).trigger('change');
      jQuery('#views-exposed-form-product-block-1 .form-submit').trigger('click');
    }
  });

  $(document).on('change', '.alphabetic-wrapper .alphabetic', function (e) {
    flag = 0;
    setTimeout(function () {
      wrappBlock();
      load_OnReady();

      $(".product-a-z .views-element-container h3").each(function (index) {
        var text = $(this).text().trim();
        // console.log(index);
        $(this).attr('data-type', text);
        setTimeout(function () {
          $('.product-a-z .views-element-container .col-row:eq(' + (index) + ')').attr('data-title', text);
        }, 300);

      });
    }, 3000);
  });

  $(".filter-block .filter-wrapper .search-outer button.btn-default").on('click', function () {
    flag = 0;
    $('.filter-block .filter-wrapper .search-outer input').val('');
    var text = $('.filter-block .filter-wrapper .search-outer input').val();
    $('#views-exposed-form-product-block-1 .form-item-combine input').val(text);
    $('#views-exposed-form-product-block-1 .form-item-field-product-type-target-id select').val('All').trigger('change');
    $('.filter-block  .selectboxit-container .selectboxit-btn .selectboxit-text').text("All");
    $('#views-exposed-form-product-block-1 .form-submit:eq(0)').trigger('click');

    $('.product-a-z .media-container .we-no-result').remove();
  });


  $(".filter-block .filter-wrapper .search-outer input").on("keyup", function (event) {
    flag = 0;
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      event.preventDefault();
      var text = $('.filter-block .filter-wrapper .search-outer input').val();
      // console.log(text);
      $('#views-exposed-form-product-block-1 .form-item-combine input').val(text);
      $('#views-exposed-form-product-block-1 .form-submit:eq(0)').trigger('click');


      if ($('.no-result').length > 0) {
        $('.product-a-z .load-more').css({ 'display': 'none' });
      }

      ExcludeChina();
    }
  });

  $(".filter-block .filter-wrapper .search-outer .search").on("click", function (event) {
    flag = 0;
    var text = $('.filter-block .filter-wrapper .search-outer input').val();
    // console.log(text);
    $('#views-exposed-form-product-block-1 .form-item-combine input').val(text);
    $('#views-exposed-form-product-block-1 .form-submit:eq(0)').trigger('click');


    setTimeout(function () {
      if ($('.no-result').length > 0) {
        $('.product-a-z .load-more').css({ 'display': 'none' });
      }
    }, 3000);

    ExcludeChina();
  });

  function ExcludeChina() {
    var geo1 = $('body').attr('data-region');

    if (geo1 == 'china') {

      $(document).ajaxComplete(function (e, xhr, settings) {
        $('.product-a-z .media-container .we-no-result').remove();
        setTimeout(function () {
          $(".filter-block .media-container .col-row").each(function () {
            // console.log(this);
            var item_length = $(this).find('.col-three').length;
            if (item_length === 0) {
              $(this).addClass('no-item').hide();
              // console.log(item_length);
              $(this).empty();
            }
          });

          $('body .filter-block .col-wrap').empty();
          setData();

          if ($(".filter-block .media-container .col-row .block-wrapper").length === 0) {
            if ($(".product-a-z .media-container .no-result").length === 0) {
              $('.product-a-z .media-container .we-no-result').remove();
              $('.product-a-z .media-container').append('<div class="we-no-result"><h2 class="text-center">No result found</h2></div>');
            }
          }

        }, 800);
      });
    }
  }

})(jQuery);


